export interface Article {
  id: string;
  title: string;
  slug: string;
  categoryId: string;
  categoryName: string;
  categorySlug: string;
  excerpt: string;
  content: string;
  coverImage: string;
  author: string;
  authorAvatar: string;
  date: string;
  readTime: string;
  tags: string[];
  featured: boolean;
}

export const articles: Article[] = [
  {
    id: "art-1",
    title: "洛丽塔风格入门：从古典到甜美的流派全解析",
    slug: "lolita-style-beginners-guide",
    categoryId: "cat-1",
    categoryName: "洛丽塔服饰文化",
    categorySlug: "lolita-culture",
    excerpt: "洛丽塔时尚拥有丰富多样的流派分支，从古典洛丽塔的优雅沉稳到甜美洛丽塔的梦幻可爱，每种风格都有其独特的魅力。本文将带你全面了解洛丽塔风格的主要流派及其核心特征。",
    content: `<p>洛丽塔时尚（Lolita Fashion）起源于日本，灵感来自维多利亚时代和洛可可时期的欧洲宫廷服饰，但经过了独特的日式美学改造，形成了一种以<strong>优雅、甜美、精致</strong>为核心的穿搭文化。</p>
<h3>洛丽塔风格的三大主要流派</h3>
<p><strong>1. 甜美洛丽塔（Sweet Lolita）</strong></p>
<p>甜美洛丽塔是最广为人知的流派，以粉色、白色、浅蓝等柔和色调为主，大量使用蝴蝶结、蕾丝、印花图案等元素。裙摆蓬松宽大，常搭配可爱的头饰和圆头鞋，整体呈现出梦幻童话般的少女感。</p>
<p><strong>2. 古典洛丽塔（Classic Lolita）</strong></p>
<p>古典洛丽塔风格更加成熟优雅，色彩偏向酒红、墨绿、深棕等沉稳色调。印花图案多为花卉、油画风格，剪裁简洁大方，适合日常穿着。这个流派强调质感和细节，是洛丽塔风格中最具古典韵味的代表。</p>
<p><strong>3. 哥特洛丽塔（Gothic Lolita）</strong></p>
<p>融合了哥特文化的暗黑元素与洛丽塔的甜美廓形，以黑色、深紫为主色调，搭配十字架、蝙蝠等哥特元素。妆容也偏向深色系，营造出一种神秘优雅而不失甜美的独特氛围。</p>
<h3>如何选择适合自己的流派？</h3>
<p>如果你是初学者，建议从甜美洛丽塔或古典洛丽塔入手。甜美洛丽塔适合喜欢可爱风格的女孩，古典洛丽塔则更适合追求优雅气质的穿搭者。可以先从印花简单的OP（One Piece连衣裙）开始尝试，逐步建立自己的洛丽塔衣橱。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Elegant%20Lolita%20fashion%20illustration%20showing%20three%20different%20styles%20sweet%20classic%20and%20gothic%20lolita%2C%20soft%20pastel%20gradient%20background%2C%20editorial%20fashion%20art%20style%2C%20delicate%20lace%20details%2C%20dreamy%20feminine%20aesthetic&width=1200&height=800&seq=art-1-cover&orientation=landscape",
    author: "樱花酱",
    authorAvatar: "https://readdy.ai/api/search-image?query=Soft%20anime%20style%20portrait%20of%20young%20woman%20with%20pink%20hair%2C%20cute%20Japanese%20illustration%2C%20simple%20clean%20background%2C%20gentle%20smile&width=200&height=200&seq=author-av-1&orientation=squarish",
    date: "2026-07-20",
    readTime: "8分钟",
    tags: ["洛丽塔入门", "风格流派", "服饰文化"],
    featured: true
  },
  {
    id: "art-2",
    title: "春夏甜美系穿搭指南：5套必学造型公式",
    slug: "spring-summer-sweet-outfit-guide",
    categoryId: "cat-2",
    categoryName: "甜美系穿搭",
    categorySlug: "sweet-style",
    excerpt: "春夏季节是甜美系穿搭的最佳时节！从轻盈的雪纺衬衫到蓬松的印花半裙，我们为你整理了5套经典造型公式，轻松穿出日系少女的清新甜美气质。",
    content: `<p>春夏季节为甜美系穿搭提供了最为广阔的舞台，轻盈的面料、明亮的色彩和丰富的层次感，让每套造型都充满了生命力。以下是5套经过验证的甜美系穿搭公式，帮助你轻松驾驭春夏造型。</p>
<h3>公式一：雪纺衬衫 + 高腰蓬裙</h3>
<p>这是甜美系穿搭最经典的组合。选择一件带有荷叶领或蝴蝶结系带的雪纺衬衫，搭配高腰印花蓬裙，瞬间营造出浪漫唯美的少女气息。颜色上可以选择粉色系、奶油白或浅蓝色，整体清新柔和。</p>
<h3>公式二：蕾丝上衣 + A字短裙</h3>
<p>蕾丝元素是甜美系穿搭的灵魂。一件精致的蕾丝上衣搭配A字短裙，既有少女的俏皮感，又不失优雅气质。建议选择米白色或淡粉色的蕾丝上衣，搭配同色系或对比色的A字裙。</p>
<h3>公式三：印花连衣裙 + 针织开衫</h3>
<p>印花连衣裙是春夏季节的必备单品，搭配一件轻薄的针织开衫，不仅能应对早晚温差，还为整体造型增添了层次感。选择小碎花或草莓、樱桃等可爱图案的连衣裙效果最佳。</p>
<h3>公式四：娃娃领衬衫 + 背带裙</h3>
<p>娃娃领衬衫自带复古甜美气息，搭配背带裙可以打造出学院风与少女感兼具的造型。选择圆领的彼得潘领衬衫效果最好，背带裙则可以选择牛仔面料或灯芯绒材质。</p>
<h3>公式五：海军领上衣 + 百褶裙</h3>
<p>海军领设计在日系风格中非常流行，搭配百褶裙可以营造出活泼灵动的少女形象。这套造型特别适合日常通勤和周末出游，舒适又甜美。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Spring%20summer%20sweet%20fashion%20outfit%20flatlay%20with%20pastel%20clothing%20items%2C%20floral%20dress%20lace%20blouse%20and%20cute%20accessories%2C%20soft%20natural%20light%2C%20cherry%20blossom%20petals%20scattered%2C%20dreamy%20feminine%20aesthetic%2C%20editorial%20fashion%20photography&width=1200&height=800&seq=art-2-cover&orientation=landscape",
    author: "樱花酱",
    authorAvatar: "https://readdy.ai/api/search-image?query=Soft%20anime%20style%20portrait%20of%20young%20woman%20with%20pink%20hair%2C%20cute%20Japanese%20illustration%2C%20simple%20clean%20background%2C%20gentle%20smile&width=200&height=200&seq=author-av-1&orientation=squarish",
    date: "2026-07-15",
    readTime: "10分钟",
    tags: ["甜美穿搭", "春夏造型", "穿搭公式"],
    featured: true
  },
  {
    id: "art-3",
    title: "原宿风到森女系：日系少女风格的演变史",
    slug: "harajuku-to-mori-girl-evolution",
    categoryId: "cat-3",
    categoryName: "日系少女风",
    categorySlug: "japanese-girly",
    excerpt: "日系少女风格经历了从原宿风、涩谷辣妹到森女系、量産型等多轮变迁。了解这些风格的演变过程，可以帮助你更好地理解和驾驭日系穿搭。",
    content: `<p>日系少女风格的发展历程，就像一部时尚文化的变迁史，每一次潮流转变都反映了当时年轻人的审美取向和生活方式。</p>
<h3>原宿风（Harajuku Style）：自由表达的极致</h3>
<p>原宿风起源于东京原宿地区，以大胆的色彩拼接、丰富的层次叠穿和极具个性的配饰为特点。它不遵循传统的穿搭规则，鼓励每个人用服装表达自我。Decora风格作为原宿风的代表分支，以大量鲜艳的塑料发夹、彩色珠串和卡通图案为标志。</p>
<h3>涩谷辣妹风（Gyaru）：叛逆的甜美</h3>
<p>涩谷辣妹风是90年代末至2000年代初最引人注目的日系风格。标志性的漂染金发、浓重眼妆、超短裙和高跟鞋，塑造了一个既性感又甜美的矛盾形象。虽然如今纯粹的辣妹风已经减少，但其影响在很多现代日系穿搭中依然可见。</p>
<h3>森女系（Mori Girl）：回归自然的温柔</h3>
<p>森女系是近年来最受欢迎的日系风格之一，强调自然、舒适和文艺气息。宽松的棉麻面料、大地色系、层次叠穿是森女系的核心元素。这个风格的女孩仿佛从森林中走出来的精灵，散发着宁静而温柔的气质。</p>
<h3>量産型（Ryousangata）：精致的日常感</h3>
<p>量産型是近年兴起的新概念，强调在可爱和日常之间找到平衡。以柔和的粉彩色调为主，搭配蕾丝、蝴蝶结等甜美元素，但整体更加简约易穿。量産型的流行反映了现代女孩对甜美风格的新理解——不需要过分华丽，日常也能穿出可爱感。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Japanese%20fashion%20style%20evolution%20collage%2C%20harajuku%20street%20style%20mori%20girl%20natural%20look%2C%20clean%20collage%20layout%2C%20editorial%20fashion%20art%2C%20minimalist%20white%20background%2C%20trendy%20Tokyo%20vibe&width=1200&height=800&seq=art-3-cover&orientation=landscape",
    author: "小鹿斑比",
    authorAvatar: "https://readdy.ai/api/search-image?query=Soft%20anime%20style%20portrait%20of%20young%20woman%20with%20brown%20hair%2C%20cute%20Japanese%20illustration%2C%20simple%20clean%20background%2C%20warm%20smile&width=200&height=200&seq=author-av-2&orientation=squarish",
    date: "2026-07-10",
    readTime: "12分钟",
    tags: ["日系风格", "原宿风", "森女系"],
    featured: true
  },
  {
    id: "art-4",
    title: "蕾丝元素穿搭法则：从入门到精通的搭配指南",
    slug: "lace-styling-master-guide",
    categoryId: "cat-4",
    categoryName: "复古蕾丝搭配",
    categorySlug: "vintage-lace",
    excerpt: "蕾丝是复古甜美风格中不可或缺的元素，但如何将蕾丝穿得精致而不显土气？本文从面料选择、款式搭配到场合建议，全面解析蕾丝穿搭技巧。",
    content: `<p>蕾丝是萝莉风格中最为核心的元素之一，它承载着浪漫、精致和女性化的美学追求。但蕾丝的搭配需要一定的技巧，稍有不慎就容易显得过时或土气。以下是从入门到精通的蕾丝穿搭指南。</p>
<h3>蕾丝面料的选择</h3>
<p>优质的蕾丝面料是穿搭成功的基础。化学蕾丝（Chemical Lace）手感柔软、花型精致，是洛丽塔服饰中最常用的类型。棉质蕾丝（Cotton Lace）更加自然透气，适合春夏季节。法国蕾丝（French Lace）以其精细的工艺和优雅的花纹闻名，适合高端定制的洛丽塔服饰。</p>
<h3>不同部位的蕾丝运用</h3>
<p><strong>蕾丝上衣：</strong>蕾丝上衣是最好入门的单品，搭配简单的牛仔裤或半身裙就能穿出复古甜美感。选择带有衬里的款式可以避免过于透视。</p>
<p><strong>蕾丝裙：</strong>蕾丝裙是甜美风格的核心单品，但要注意长度的选择。过膝的长度更显优雅复古，短款则更活泼可爱。</p>
<p><strong>蕾丝配饰：</strong>对于蕾丝穿搭新手，从配饰入手是最稳妥的方式。蕾丝手套、蕾丝发带、蕾丝手帕都是不错的选择，能为整体造型增添精致感。</p>
<h3>蕾丝搭配的黄金法则</h3>
<p>1. 全身不超过两处蕾丝元素，避免累赘。</p>
<p>2. 用简约单品平衡蕾丝的繁复感，如纯色T恤或简约外套。</p>
<p>3. 注意蕾丝的颜色搭配，同色系最安全，撞色需要较高的搭配功力。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Closeup%20of%20delicate%20cream%20lace%20fabric%20with%20floral%20pattern%2C%20vintage%20fashion%20detail%2C%20soft%20warm%20lighting%2C%20elegant%20textile%20texture%2C%20romantic%20nostalgic%20mood%2C%20editorial%20fashion%20photography&width=1200&height=800&seq=art-4-cover&orientation=landscape",
    author: "小鹿斑比",
    authorAvatar: "https://readdy.ai/api/search-image?query=Soft%20anime%20style%20portrait%20of%20young%20woman%20with%20brown%20hair%2C%20cute%20Japanese%20illustration%2C%20simple%20clean%20background%2C%20warm%20smile&width=200&height=200&seq=author-av-2&orientation=squarish",
    date: "2026-07-05",
    readTime: "7分钟",
    tags: ["蕾丝搭配", "复古风格", "穿搭技巧"],
    featured: false
  },
  {
    id: "art-5",
    title: "蝴蝶结与发带的艺术：萝莉风格配饰完全手册",
    slug: "bows-and-headbands-accessory-guide",
    categoryId: "cat-5",
    categoryName: "配件搭配",
    categorySlug: "accessories",
    excerpt: "头饰是萝莉风格中最具标志性的配件，从巨大的蝴蝶结发箍到精致的花环形发带，选择正确的头饰可以让整体造型提升好几个层次。",
    content: `<p>在萝莉风格的穿搭中，配件扮演着画龙点睛的角色。尤其是头饰，几乎可以说是洛丽塔造型的灵魂所在。本篇文章将详细介绍各种萝莉风格头饰的类型和搭配技巧。</p>
<h3>蝴蝶结类头饰</h3>
<p><strong>大发箍蝴蝶结（Headbow）：</strong>这是洛丽塔最经典的头饰类型，通常用于搭配较为正式的造型。尺寸较大的蝴蝶结能够平衡蓬松的裙摆，在视觉上形成和谐的上下比例。选择与裙子同色或同印花面料的蝴蝶结是最保险的搭配方式。</p>
<p><strong>侧夹蝴蝶结（Side Clip）：</strong>小巧精致的侧夹蝴蝶结适合日常甜系穿搭，可以别在耳后或马尾处，增添不经意的甜美细节。</p>
<h3>发带类头饰</h3>
<p><strong>花环发带（Flower Crown）：</strong>花环发带特别适合春夏季节的森女系和甜美系造型。选择人造花材质的花环更加持久耐看，颜色上可以呼应服装的主色调。</p>
<p><strong>蕾丝发带（Lace Headband）：</strong>蕾丝发带是复古风格的必备配饰，搭配卷发造型尤为出彩。米白色蕾丝发带最为百搭，黑色蕾丝则适合哥特洛丽塔风格。</p>
<h3>其他配饰推荐</h3>
<p>除了头饰，精致的手袋、蕾丝手套、珍珠项链、过膝袜也是萝莉风格中不可或缺的配件。选择配件时要注意与整体造型的风格统一，避免元素过于混杂。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Beautiful%20collection%20of%20lolita%20hair%20accessories%20with%20bows%20headbands%20and%20flower%20crowns%2C%20arranged%20on%20vintage%20vanity%20table%2C%20soft%20pastel%20background%2C%20feminine%20delicate%20aesthetic%2C%20editorial%20still%20life%20photography&width=1200&height=800&seq=art-5-cover&orientation=landscape",
    author: "樱花酱",
    authorAvatar: "https://readdy.ai/api/search-image?query=Soft%20anime%20style%20portrait%20of%20young%20woman%20with%20pink%20hair%2C%20cute%20Japanese%20illustration%2C%20simple%20clean%20background%2C%20gentle%20smile&width=200&height=200&seq=author-av-1&orientation=squarish",
    date: "2026-06-28",
    readTime: "9分钟",
    tags: ["配件推荐", "蝴蝶结", "头饰搭配"],
    featured: false
  },
  {
    id: "art-6",
    title: "洛丽塔裙撑选择攻略：如何穿出完美蓬松感",
    slug: "lolita-petticoat-guide",
    categoryId: "cat-1",
    categoryName: "洛丽塔服饰文化",
    categorySlug: "lolita-culture",
    excerpt: "裙撑（Petticoat）是洛丽塔造型的灵魂配件，不同的裙撑材质和形状会影响裙摆的蓬松度和整体轮廓。学会选择合适的裙撑，让你的洛丽塔造型更加完美。",
    content: `<p>裙撑是洛丽塔穿搭中最重要的配件之一，它决定了裙摆的蓬松程度和整体轮廓。一个合适的裙撑能让普通的连衣裙瞬间拥有洛丽塔风格的标志性廓形。</p>
<h3>裙撑的类型</h3>
<p><strong>A字裙撑：</strong>最经典的裙撑类型，呈现出优雅的A字形轮廓。适合古典洛丽塔和日常甜系穿搭，自然不夸张。通常为2-3层纱质面料。</p>
<p><strong>钟形裙撑：</strong>底部更加宽大蓬松，呈现出钟形的轮廓。这种裙撑适合需要更加夸张效果的正装洛丽塔造型，如茶会、聚会等场合。通常为4-5层纱质面料。</p>
<p><strong>鱼骨裙撑：</strong>在面料夹层中加入鱼骨支撑条，不需要多层纱就能达到蓬松效果。夏季穿着更加凉爽透气。</p>
<h3>如何选择合适的裙撑</h3>
<p>选择裙撑时需要考虑裙子的长度和风格。膝盖长度的裙子适合A字裙撑，脚踝长度的长裙则适合钟形裙撑。甜美洛丽塔可以大胆选择更加蓬松的裙撑，古典洛丽塔则建议选择稍克制的款式。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Lolita%20fashion%20petticoat%20display%20showing%20different%20silhouettes%2C%20layers%20of%20tulle%20and%20lace%2C%20soft%20cream%20and%20white%20colors%2C%20elegant%20fashion%20detail%2C%20editorial%20photography%2C%20clean%20white%20background&width=1200&height=800&seq=art-6-cover&orientation=landscape",
    author: "小鹿斑比",
    authorAvatar: "https://readdy.ai/api/search-image?query=Soft%20anime%20style%20portrait%20of%20young%20woman%20with%20brown%20hair%2C%20cute%20Japanese%20illustration%2C%20simple%20clean%20background%2C%20warm%20smile&width=200&height=200&seq=author-av-2&orientation=squarish",
    date: "2026-06-22",
    readTime: "6分钟",
    tags: ["裙撑", "洛丽塔配件", "穿搭干货"],
    featured: false
  },
  {
    id: "art-7",
    title: "粉色系配色方案：打造梦幻甜美造型的色彩学",
    slug: "pink-color-palette-styling",
    categoryId: "cat-2",
    categoryName: "甜美系穿搭",
    categorySlug: "sweet-style",
    excerpt: "粉色是甜美系穿搭的代表色，但你知道吗？粉色也有冷暖调之分，不同的粉色系搭配会呈现出截然不同的风格效果。掌握粉色系配色技巧，让你的甜美造型更上层楼。",
    content: `<p>粉色是甜美系穿搭的灵魂色彩，但粉色世界远比我们想象的更加丰富多彩。从樱花粉到玫瑰粉，从浅桃色到藕荷粉，每一种粉色都有其独特的温度和情感表达。</p>
<h3>粉色系的冷暖调分类</h3>
<p><strong>冷调粉色：</strong>带有蓝紫色底色，如樱花粉、薰衣草粉。适合皮肤偏白的女生，能衬托出清冷优雅的气质。</p>
<p><strong>暖调粉色：</strong>带有黄橙色底色，如蜜桃粉、珊瑚粉。更加柔和温暖，适合亚洲人的暖黄肤色，能显得气色红润。</p>
<p><strong>中性粉色：</strong>如婴儿粉、千禧粉，不偏冷不偏暖，最为百搭。</p>
<h3>粉色系的经典搭配方案</h3>
<p>1. 同色系渐变：从浅粉到深粉的层次搭配，打造和谐统一的视觉效果。</p>
<p>2. 粉色+白色：最经典的甜美组合，清新纯净。</p>
<p>3. 粉色+灰色：用灰色中和粉色的甜腻感，增添成熟气质。</p>
<p>4. 粉色+奶油色：温暖柔和的组合，特别适合秋冬季节。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Beautiful%20pink%20color%20palette%20with%20fashion%20fabric%20swatches%2C%20soft%20gradient%20from%20light%20to%20dark%20pink%2C%20delicate%20lace%20and%20ribbon%20details%2C%20editorial%20fashion%20flatlay%2C%20dreamy%20feminine%20aesthetic%2C%20clean%20composition&width=1200&height=800&seq=art-7-cover&orientation=landscape",
    author: "樱花酱",
    authorAvatar: "https://readdy.ai/api/search-image?query=Soft%20anime%20style%20portrait%20of%20young%20woman%20with%20pink%20hair%2C%20cute%20Japanese%20illustration%2C%20simple%20clean%20background%2C%20gentle%20smile&width=200&height=200&seq=author-av-1&orientation=squarish",
    date: "2026-06-18",
    readTime: "7分钟",
    tags: ["色彩搭配", "粉色系", "甜美穿搭"],
    featured: false
  },
  {
    id: "art-8",
    title: "秋冬萝莉风格穿搭：保暖与可爱如何兼得",
    slug: "autumn-winter-lolita-styling",
    categoryId: "cat-2",
    categoryName: "甜美系穿搭",
    categorySlug: "sweet-style",
    excerpt: "秋冬季节还能穿萝莉风格吗？当然可以！从毛呢斗篷到针织连裤袜，从贝雷帽到毛毛领，秋冬萝莉风格同样可以既保暖又可爱。",
    content: `<p>很多女孩一到秋冬季就把心爱的洛丽塔裙子收进衣柜，其实这是一个误区。洛丽塔风格在秋冬季同样可以大放异彩，而且秋冬面料带来的质感和层次感是春夏无法比拟的。</p>
<h3>秋冬洛丽塔的必备单品</h3>
<p><strong>毛呢斗篷：</strong>斗篷是秋冬洛丽塔风格的标志性单品，不仅可以保暖，还能营造出优雅的古典气质。选择红色、酒红色或墨绿色的毛呢斗篷最为经典。</p>
<p><strong>针织连裤袜：</strong>用针织连裤袜替代夏季的白色短袜，保暖的同时保持可爱感。选择带有蕾丝花边或蝴蝶结装饰的款式效果更佳。</p>
<p><strong>毛毛领和毛毛袖口：</strong>在JK或洛丽塔外套上添加毛毛领和毛毛袖口，瞬间提升奢华感和温暖度。</p>
<h3>秋冬穿搭层次法则</h3>
<p>1. 内层：高领蕾丝打底衫，精致又保暖。</p>
<p>2. 中层：洛丽塔连衣裙或JSK（无袖连衣裙），搭配长袖衬衫。</p>
<p>3. 外层：毛呢斗篷或短款毛呢外套，长度刚好露出裙摆。</p>
<p>4. 配饰：贝雷帽、围巾、手套等保暖配饰。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Autumn%20winter%20lolita%20fashion%20outfit%20with%20wool%20cape%20and%20knitted%20tights%2C%20warm%20burgundy%20and%20cream%20color%20palette%2C%20cozy%20cafe%20background%2C%20soft%20warm%20lighting%2C%20editorial%20fashion%20photography%2C%20elegant%20feminine%20style&width=1200&height=800&seq=art-8-cover&orientation=landscape",
    author: "小鹿斑比",
    authorAvatar: "https://readdy.ai/api/search-image?query=Soft%20anime%20style%20portrait%20of%20young%20woman%20with%20brown%20hair%2C%20cute%20Japanese%20illustration%2C%20simple%20clean%20background%2C%20warm%20smile&width=200&height=200&seq=author-av-2&orientation=squarish",
    date: "2026-06-12",
    readTime: "8分钟",
    tags: ["秋冬穿搭", "保暖时尚", "甜美风格"],
    featured: false
  },
  {
    id: "art-9",
    title: "国牌洛丽塔品牌推荐：值得关注的原创设计",
    slug: "chinese-lolita-brands-recommendation",
    categoryId: "cat-1",
    categoryName: "洛丽塔服饰文化",
    categorySlug: "lolita-culture",
    excerpt: "中国洛丽塔市场近年来蓬勃发展，涌现出大量优秀的原创设计品牌。本文为你盘点了最值得关注的国牌洛丽塔品牌，从平价到高端一应俱全。",
    content: `<p>随着洛丽塔文化在中国的普及，国牌洛丽塔品牌也迎来了蓬勃发展期。越来越多的中国设计师开始在洛丽塔服饰领域展现才华，创造出兼具东方美学和洛丽塔风格的原创作品。</p>
<h3>国牌洛丽塔的发展历程</h3>
<p>中国洛丽塔市场从最初的代购日牌为主，到如今原创品牌百花齐放，经历了十余年的发展。早期国牌以高性价比著称，如今则在设计感和品质上都达到了国际水平。</p>
<h3>值得关注的国牌推荐</h3>
<p>目前市场上活跃着数十个国牌洛丽塔品牌，每个品牌都有自己独特的设计理念和风格定位。有的品牌专注于甜美洛丽塔的印花设计，有的则擅长古典洛丽塔的优雅剪裁。建议新手从口碑好、价格适中的品牌开始尝试，逐步找到最适合自己的品牌和风格。</p>
<p>在选择品牌时，建议关注以下几个维度：面料品质、印花精度、剪裁合身度以及品牌的售后服务。一件优秀的洛丽塔服饰应该在这些方面都达到较高的水准。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Elegant%20Chinese%20original%20design%20lolita%20dress%20display%2C%20beautiful%20floral%20print%20on%20soft%20fabric%2C%20oriental%20aesthetic%20meets%20western%20lolita%20style%2C%20editorial%20fashion%20photography%2C%20soft%20natural%20lighting%2C%20artistic%20composition&width=1200&height=800&seq=art-9-cover&orientation=landscape",
    author: "樱花酱",
    authorAvatar: "https://readdy.ai/api/search-image?query=Soft%20anime%20style%20portrait%20of%20young%20woman%20with%20pink%20hair%2C%20cute%20Japanese%20illustration%2C%20simple%20clean%20background%2C%20gentle%20smile&width=200&height=200&seq=author-av-1&orientation=squarish",
    date: "2026-06-05",
    readTime: "9分钟",
    tags: ["品牌推荐", "国牌洛丽塔", "原创设计"],
    featured: false
  },
  {
    id: "art-10",
    title: "袜子的魔法：过膝袜与短袜的甜美搭配技巧",
    slug: "socks-styling-lolita-guide",
    categoryId: "cat-5",
    categoryName: "配件搭配",
    categorySlug: "accessories",
    excerpt: "袜子是萝莉风格中被低估的搭配利器，从白色过膝袜到蕾丝花边短袜，选择对的那双袜子能让腿部线条更加优美，整体造型更加完整。",
    content: `<p>袜子虽小，却是萝莉风格穿搭中不可或缺的细节元素。一双合适的袜子不仅能修饰腿部线条，还能为整体造型增添层次感和精致度。</p>
<h3>过膝袜（Knee-high Socks）</h3>
<p>过膝袜是洛丽塔穿搭中最经典的选择，长度刚好到膝盖上方，能有效修饰小腿线条。白色过膝袜最为经典百搭，黑色过膝袜则适合哥特风格。带有蕾丝花边或蝴蝶结装饰的过膝袜更加精致甜美。</p>
<h3>短袜（Ankle Socks）</h3>
<p>蕾丝花边短袜是春夏季节的好选择，搭配玛丽珍鞋或圆头娃娃鞋特别可爱。选择带有小蝴蝶结或珍珠装饰的款式，细节处彰显精致品味。</p>
<h3>裤袜（Tights）</h3>
<p>秋冬季节可以选择印花裤袜，如心形图案、小圆点图案等。白色裤袜是甜美洛丽塔的经典之选，但需要注意选择质地细腻、不透肉的品质款。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Cute%20collection%20of%20lolita%20socks%20and%20tights%20with%20lace%20trim%20and%20ribbon%20details%2C%20white%20pink%20and%20cream%20colors%2C%20arranged%20with%20mary%20jane%20shoes%2C%20soft%20pastel%20background%2C%20editorial%20still%20life%2C%20feminine%20delicate%20aesthetic&width=1200&height=800&seq=art-10-cover&orientation=landscape",
    author: "小鹿斑比",
    authorAvatar: "https://readdy.ai/api/search-image?query=Soft%20anime%20style%20portrait%20of%20young%20woman%20with%20brown%20hair%2C%20cute%20Japanese%20illustration%2C%20simple%20clean%20background%2C%20warm%20smile&width=200&height=200&seq=author-av-2&orientation=squarish",
    date: "2026-05-28",
    readTime: "5分钟",
    tags: ["袜子搭配", "过膝袜", "配件推荐"],
    featured: false
  }
];